<template>
  <div id="pageDashboard">
    <v-toolbar class="top-content" flat>
      <v-toolbar-title class="title-box pt-3">
        <span class="title">Reference Number Information</span>
        <v-text-field
          @click:clear="searchReference"
          append-icon="search"
          class="inp-search"
          clearable
          placeholder="Search"
          v-model="search"
          v-on:keydown="searchReference"
        ></v-text-field>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- dialog -->
      <v-dialog
        content-class="dialog-reference"
        max-width="700px"
        persistent
        v-model="dialog"
      >
        <v-card>
          <v-card-title>{{ formTitle }}</v-card-title>
          <v-form
            data-vv-scope="formReference"
            lazy-validation
            ref="formReference"
            v-model="validForm"
          >
            <v-card-text class="pt-0">
              <v-container grid-list-md pb-0>
                <v-layout wrap>
                  <v-flex md12 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength100]"
                      required
                      data-vv-delay="500"
                      data-vv-name="reference_number"
                      label="Reference Number"
                      v-model="editedItem.reference_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md12 xs12>
                    <v-autocomplete
                      :items="userList"
                      :loading="loadingSelectUser"
                      :rules="[rules.maxlength2]"
                      multiple
                      required
                      label="Select user assign"
                      chips
                      clearable
                      :counter="2"
                      v-model="editedItem.user_id"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogConfirm = true">Cancel</v-btn>
              <v-btn @click="save" color="primary">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450px" persistent v-model="dialogStatus">
        <v-card>
          <v-card-title>
            <span class="headline">Alert</span>
          </v-card-title>
          <v-card-text>{{ res_msg }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogStatus = false" style="width: 85px"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450px" persistent v-model="dialogConfirm">
        <v-card>
          <v-card-title>
            <span class="headline">Alert</span>
          </v-card-title>
          <v-card-text>{{ title2 }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
            <v-btn @click="close" color="primary" style="width: 85px"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end dialog -->
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="moduleData"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="totalItems"
      class="elevation-1 list-survey"
      item-key="name"
    >
      <template v-slot:headers="props">
        <th
          :class="[
            'column',
            !(typeof header.sortable === 'boolean' && !header.sortable)
              ? 'sortable'
              : '',
            header.align ? header.align : 'text-xs-left',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '',
          ]"
          :key="header.text"
          @click="changeSort(header)"
          v-for="header in props.headers"
        >
          {{ header.text }}
          <v-icon
            small
            v-if="!(typeof header.sortable === 'boolean' && !header.sortable)"
            >arrow_upward</v-icon
          >
        </th>
      </template>
      <template slot="items" slot-scope="props">
        <tr
          :active="props.selected"
          @click="props.selected = !props.selected"
          style="color: rgba(0, 0, 0, 0.87) !important"
        >
          <td class="text-xs-left">
            <router-link
              :to="{
                name: 'Reference_Number_Detail',
                params: { id: props.item._id },
              }"
              >{{ props.item.reference_number }}</router-link
            >
          </td>
          <td class="text-xs-left">
            <router-link
              :to="{
                name: 'Reference_Number_Detail',
                params: { id: props.item._id },
              }"
            >
              <span v-for="items in props.item.users" :key="items._id">
                {{ items.full_name }}</span
              >
            </router-link>
          </td>
          <td class="text-xs-right">
            <v-icon @click="editItem(props.item)" class="mr-2" small>
              edit
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:actions-prepend>
        <div class="actions-list">
          <v-btn @click="eventAddReference($event)" color="primary">
            Add
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ReferenceService from "../services/referenceNumber.service";
import UserService from "../services/user.service.js";
import { debounce, isEmpty } from "lodash";
export default {
  inject: ["$validator"],
  metaInfo() {
    return {
      title: "Manage Reference",
    };
  },
  data: () => ({
    isAdmin: 4,
    isSuperAdmin: 3,
    validForm: true,
    dialogStatus: false,
    res_msg: "",
    pagination: {
      rowsPerPage: 10,
      sortBy: "createdAt",
      descending: true,
      page: 1,
    },
    totalItems: 0,
    rowsPerPageItems: [10, 20, 50],
    breadcrumbs: [
      {
        text: "Reference",
      },
    ],
    referenceService: new ReferenceService(),
    userService: new UserService(),
    editedIndex: -1,
    dialog: false,
    editedItem: {
      reference_number: "",
      user_id: "",
    },
    id: "",
    userList: [],
    sortBy: "",
    loading: false,
    searchSale: null,
    search: null,
    loadingSelectUser: false,
    rules: {
      maxlength2: (v) =>
        (v && v.length > 0 && v.length <= 2) ||
        "Min 1 item select max 2 item selected",
      required: (v) => (v && v.trim().length > 0) || "It is required field",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      arrRequired: (values) => values.length > 0 || "It is required field",
      emails: (values) => {
        const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        for (let i = 0; i < values.length; i++) {
          if (!pattern.test(values[i])) {
            return "Invalid e-mail.";
          }
        }
        return true;
      },
      maxLength100: (v) => (v && v.length <= 100) || "Max 100 characters",
      maxLength50: (v) => (v && v.length <= 50) || "Max 50 characters",
      maxValue100: (v) => v <= 100 || "Max 100 floors",
      maxLength300: (v) => (v && v.length <= 300) || "Max 300 characters",
      minValue: (v) => v >= 0 || "Min 0 floor",
      noOfStops: {
        valid: (v) =>
          (!isNaN(parseFloat(v)) && isFinite(v)) ||
          (v === "" ? "It is required  field" : "Invalid Number"),
        required: (v) => !!v || "It is required  field",
      },
    },
    headers: [
      {
        text: "Reference Number",
        value: "reference_number",
      },
      {
        text: "User Name",
        value: "user_id",
      },
      {
        text: "Action",
        sortable: false,
        align: "text-xs-right",
      },
    ],
    moduleData: [],
    dictionary: {
      custom: {
        reference_number: {
          required: () => "It is required field",
          max: () => "Max 100 characters",
          regex: () => "The Reference Number field format is invalid.",
        },
        phone_number: {
          regex: () => "The phone number field is numbers.",
        },
        valid_floor: {
          required: () => "It is required field",
          max_value: () => "Max 100 floors",
          regex: () => "Invalid No. of stops",
        },
        autocomplete_field: {
          required: () => "It is required field",
        },
      },
    },
    clickAdd: true,
    dialogConfirm: false,
  }),
  created() {
    this.searchDataUser({
      limit: 1000,
    });
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    searchUser(query) {
      this.querySearch({
        search: query,
        limit: 1000,
      });
    },
  },
  mounted() {},
  computed: {
    // là các pure-func đc cache lại và chỉ re-render khi mà có gtri thay đổi, k có params.

    formTitle() {
      return this.editedIndex === -1
        ? "Add Reference Number"
        : "Edit Reference Number 2";
    },
    title2() {
      return this.editedIndex === -1
        ? "Are you sure to cancel the new reference number?"
        : "Are you sure to cancel the changes?";
    },
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },
  },
  methods: {
    changeSort(data) {
      if (typeof data.sortable === "boolean" && !data.sortable) return;
      const column = data.value;
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.pagination.page = 1;
    },
    searchReference: debounce(function searchReference() {
      this.getData();
    }, 800),
    querySearch: debounce(function querySearch(query) {
      this.loadingSelectUser = true;
      this.searchDataUser(query);
    }, 500),
    searchDataUser(query) {
      this.userService.getList(query).then((res) => {
        if (res && res.docs) {
          this.userList = res.docs.map((e) => {
            return {
              text: [e.first_name, e.last_name].join(" ") + "<" + e.email + ">",
              value: e.id,
            };
          });
        }
        this.loadingSelectUser = false;
      });
    },
    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.clickAdd = true;
      setTimeout(() => {
        this.editedIndex = -1;
        this.$refs.formReference.reset();
        this.$validator.reset();
      }, 500);
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
      };
      if (!isEmpty(this.search)) params.search = this.search;
      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }
      this.referenceService.getList(params).then((res) => {
        this.loading = false;
        if (res && res.docs) {
          this.moduleData = res.docs;
          this.totalItems = res.total;
        }
      });
    },
    eventAddReference() {
      this.dialog = true;
      this.validForm = false;
      setTimeout(function () {
        document.getElementsByClassName("dialog-reference")[0].scrollTop = 0;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.moduleData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.id = this.moduleData[this.editedIndex]._id;
      this.dialog = true;
    },
    postReference(data) {
      if (this.editedIndex === -1) {
        this.referenceService.add(data).then((res) => {
          this.clickAdd = true;
          if (res.data && res.data.statusCode === 200) {
            this.pagination.sortBy = "createdAt";
            this.pagination.descending = true;
            this.getData();
            this.close();
          } else {
            this.dialogStatus = true;
            this.res_msg = res.data.message;
          }
        });
      } else {
        this.referenceService.edit(data, this.id).then((res) => {
          this.clickAdd = true;

          if (res.data && res.data.statusCode === 200) {
            this.pagination.sortBy = "createdAt";
            this.pagination.descending = true;
            this.getData();
            this.close();
          } else {
            this.dialogStatus = true;
            this.res_msg = res.data.message;
          }
        });
      }
    },
    async save() {
      if (!this.clickAdd) return;
      this.clickAdd = false;
      this.$validator.validate("formReference.*").then((result) => {
        if (result) {
          if (this.$refs.formReference.validate()) {
            const { editedItem } = this;
            const data = {
              ...editedItem,
            };

            this.postReference(data);
          } else {
            this.clickAdd = true;
          }
        } else {
          this.clickAdd = true;
          this.$refs.formReference.validate();
        }
      });
    },
  },
};
</script>

<style>
li {
  text-decoration: none;
  list-style-type: none;
}

.list-poo img {
  max-width: 200px;
}

.dropbox {
  /*outline: 2px dashed grey; !* the dash box *!*/
  outline-offset: -10px;
  /*background: lightcyan;*/
  color: dimgray;
  padding: 10px 10px;
  /*min-height: 200px; !* minimum height *!*/
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 100%;
  height: 50px;
  position: absolute;
  left: 10px;
  margin-top: 10px;
  top: 0;
  cursor: pointer;
}

.dropbox:hover {
  /*background: lightblue; !* when mouse over to the drop zone, change color *!*/
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.v-toolbar__content {
  /* height: 100% !important; */
}

/* @media screen and (max-width: 600px) {
     .inp-search {
        order: -1;
        flex: 1 0 100%;
    }
} */
table.v-table tbody td a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
}

.title-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.inp-search {
  max-width: 440px;
  width: 100%;
}

.group-control {
  text-align: center;
}

#pageDashboard .v-datatable__actions {
  position: relative;
}

@media screen and (min-width: 1080px) {
  .actions-list {
    left: calc(50% - 55px);
  }
}

.actions-list {
  position: absolute;
  top: 5px;
}

.v-card__title {
  font-size: 18px;
  font-weight: bold;
  background-color: #f5f5f5;
}

.v-card__actions {
  padding: 15px 10px;
}

.top-content {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
}

table.v-table tbody td {
  word-break: break-word;
}

.list-survey tbody tr td:nth-child(1) {
  min-width: 150px;
}

.file-listing {
  display: flex;
}

.name-file {
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.accent--text {
  color: #0779ff !important;
}
</style>
